import Vue from 'vue'

class EntidadeService {
  async busca(
    uf,
    entidadeId
  ) {
    try {
      const response = await Vue.prototype.$http.get(
        `entidade/${uf}/${entidadeId}`
      )
      return await response.data;
    } catch (error) {
      throw error
    }
  }
}

export default new EntidadeService();
